import Form from './Form.js';
import './App.css';

function App() {
  return (
    <div className="App" style={{ backgroundImage: "linear-gradient(to right, #ffffed, #019CAD)"  }}>
      <Form/>
    </div>
  );
}

export default App;
